module.exports = {"school-name":"North Idaho College","logo":"/sites/nic/logo.png","logout":"/sites/nic/logout.png","logout-color":"#781126","logout-font-color":"#ffffff","header-color":"#000000","header-border-color":"#781126","footer-color":"#000000","footer-info":"© 2019 North Idaho College | The Write Class™ | © 2019 Boise State University","help-button-color":"#781126","help-button-font-color":"#FFFFFF"}


//////////////////
// WEBPACK FOOTER
// ./sites/nic/site-config.json
// module id = 116
// module chunks = 12